<template>
  <div ref="chart" style="width: 100%;height:250px;"></div>
</template>

<script>
import echarts from 'echarts'
import { mapGetters } from 'vuex'
export default {
  props: {
    chartData: {
      type: Array
    }
  },
  computed: {},
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          // formatter: (params) => {
          //   //使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
          //   return `${this.$t('calendar.readTime')} ：${this.millisecondToDate(
          //     params[0].value
          //   )}`
          // },

          // borderRadius: 20,
          // borderWidth: 1,
          // borderColor: '#BF735B',
          // padding: [2, 8],
          // textStyle: {
          //   color: '#BF735B',
          //   fontSize: 12,
          //   fontWeight: 300
          // },
          axisPointer: {
            lineStyle: {
              type: 'solid',
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(191,115,91,0)'
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(191,115,91,0.8)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(191,115,91,0)'
                  }
                ],
                global: false
              }
            }
          }
        },
        grid: {
          show: false,
          left: '3%',
          right: '4%',
          top: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              rotate: 65,
              interval: 0 // 全部显示
            },
            axisTick: {
              show: true //不显示坐标轴刻度线
            },
            data: [],
            axisLine: {
              show: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: false,
            min: 0,
            splitNumber: 0,
            boundaryGap: [0.2, 0.2],
            splitLine: {
              lineStyle: {
                width: 1
              }
            },
            axisLabel: {
              show: true //不显示坐标轴上的文字
            }
          }
        ],
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#BF735B'
              // shadowColor: 'rgba(0, 0, 0, 1)',
              // shadowBlur: 10,
              // shadowOffsetY: 5
            },
            itemStyle: {
              color: '#fff',
              borderColor: '#BF735B',
              borderWidth: 1,
              shadowColor: 'rgba(0, 0, 0, 1)',
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: 'rgba(191,115,91,0.5)'
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(191,115,91, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(191,115,91,0)'
                  }
                ],
                false
              ),
              shadowColor: 'rgba(191,115,91, 0.8)',
              shadowBlur: 20
            }
          }
        ]
      }
    }
  },
  methods: {
    chartResize() {
      this.myChart.resize({ width: 'auto' })
    },
    initChart() {
      if (!this.myChart) {
        this.myChart = echarts.init(this.$refs.chart)
      }
      this.option.series[0].data = this.chartData.map((item) => item.count)
      this.option.xAxis[0].data = this.chartData.map((item) => item.date)
      this.myChart.setOption(this.option)
    }

    // millisecondToDate(millisec) {
    //   if (parseFloat(millisec)) {
    //     var seconds = (millisec / 1000).toFixed(0)
    //     var minutes = Math.floor(seconds / 60)
    //     var hours = ''
    //     if (minutes > 59) {
    //       hours = Math.floor(minutes / 60)
    //       minutes = minutes - hours * 60
    //     }

    //     seconds = Math.floor(seconds % 60)
    //     if (hours != '') {
    //       return hours + this.$t('common.h') + minutes + this.$t('common.m')
    //     } else if (minutes || minutes > 0) {
    //       return minutes + this.$t('common.m')
    //     } else {
    //       return seconds + this.$t('common.s')
    //     }
    //   } else {
    //     return '0'
    //   }
    // }
  },
  watch: {
    chartData() {
      // this.option.tooltip.formatter = `${ this.$t('calendar.readTime') } ：{ c0 } `
      this.initChart()
    }
  },
  mounted() {
    // this.option.tooltip.formatter = `${ this.$t('calendar.readTime') } ：{ c0 }`
    this.initChart()
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  }
}
</script>
